import React, { useEffect, useState } from "react";
import { Provider } from "react-redux";
import GlobalStyles from "@iso/assets/styles/globalStyle";
import { store } from "./redux/store";
import Boot from "./redux/boot";
import Routes from "./router";
import AppProvider from "./AppProvider";
import Maintenancef from "./containers/Pages/404/404Outside";
import ApiCall from "./library/helpers/ApiCall";

const App = () => {
  const [maintenance, setMaintenance] = useState(false);

  useEffect(() => {
    // Set a timeout to redirect to maintenance if the loading takes too long
    const timeoutId = setTimeout(() => {
      if (window.location.pathname !== "/Maintenance") {
        window.location.pathname = "/Maintenance";
      }
    }, 15000); // 15 seconds

    ApiCall.get("/Setting/IsMaintenance", null, { dontLoad: true })
      .then((response) => {
        clearTimeout(timeoutId); // Clear the timeout if the API call completes in time
        setMaintenance(response.data.RESULT == "1");
        const isMaintenance = response.data?.RESULT == "1";
        if (isMaintenance && window.location.pathname !== "/Maintenance") {
          window.location.pathname = "/Maintenance";
        }
      })
      .catch((error) => {
        clearTimeout(timeoutId); // Clear the timeout if there's an error
        // If API call fails, redirect to maintenance page
        if (window.location.pathname !== "/Maintenance") {
          window.location.pathname = "/Maintenance";
        }
      });

    return () => clearTimeout(timeoutId); // Cleanup timeout on unmount
  }, []);

  return (
    <>
      {maintenance ? (
        <Maintenancef />
      ) : (
        <Provider store={store}>
          <AppProvider>
            <>
              <GlobalStyles />
              <Routes />
            </>
          </AppProvider>
        </Provider>
      )}
    </>
  );
};

Boot()
  .then(() => App())
  .catch((error) => console.error(error));

export default App;
